
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bao-chi-noi-ve-tnh",
      function () {
        return require("private-next-pages/bao-chi-noi-ve-tnh/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bao-chi-noi-ve-tnh"])
      });
    }
  